export const ALLOWED_MANUFACTURERS: string[] = ['audi', 'cupra', 'volkswagen', 'seat', 'skoda'];

type AllowedManufactures = (typeof ALLOWED_MANUFACTURERS)[number];
export const DEFAULT_MANUFACTURE_ALIAS = 'default';
export type ManufactureType = AllowedManufactures | 'default';

// Maps the `?manufacturer=` slug onto the car_brand cid used by GET /wp/planner/car-brands.
export const MANUFACTURER_BRAND_CIDS: Record<string, string> = {
  audi: 'AUDI',
  cupra: 'CURP',
  seat: 'SEAP',
  skoda: 'SKOD',
  volkswagen: 'VOLK',
};

export function brandCidForManufacturer(manufacturer: string | null | undefined): string | null {
  return MANUFACTURER_BRAND_CIDS[(manufacturer ?? '').trim().toLowerCase()] ?? null;
}
